// extracted by mini-css-extract-plugin
export default {"PostCreate":"qg_a bhl_qt bhl_a bhl_w bhl_ea"};